import type { AppLocale } from '@nest-react/lib';
import type { CompanyWorkspace, WorkspaceContract } from '@nest-react/domain';
import { useShallow } from 'zustand/react/shallow';

import {
  selectActiveCompany,
  selectActiveWorkspace,
  selectActiveWorkspaceId,
  useWorkspaceStore,
} from './workspaceStore';

export const useActiveWorkspaceId = (): string | null =>
  useWorkspaceStore(selectActiveWorkspaceId);

export const useActiveWorkspace = (): WorkspaceContract | null =>
  useWorkspaceStore(selectActiveWorkspace);

export const useActiveCompany = (): CompanyWorkspace | null =>
  useWorkspaceStore(selectActiveCompany);

export const useWorkspaceLocale = (): AppLocale =>
  useWorkspaceStore(state => state.identity.locale);

export const useWorkspaceIdentity = (): {
  activeWorkspaceId: string | null;
  activeWorkspace: WorkspaceContract | null;
  activeCompany: CompanyWorkspace | null;
  workspaceContracts: WorkspaceContract[];
  companies: CompanyWorkspace[];
  locale: AppLocale;
} =>
  useWorkspaceStore(
    useShallow(state => ({
      activeWorkspaceId: selectActiveWorkspaceId(state),
      activeWorkspace: selectActiveWorkspace(state),
      activeCompany: selectActiveCompany(state),
      workspaceContracts: state.identity.workspaceContracts,
      companies: state.identity.companies,
      locale: state.identity.locale,
    }))
  );
